import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import DespatchMonitoringReport from '../../common/components/DespatchMonitoringReport';
import {
  getCalculatedData,
  getColumns,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchMonitoringResponsePerformanceSelectors';

export class DespatchMonitoringResponsePerformanceContainer extends Component {
  getTrProps = (state, rowInfo) => {
    let classNameValue = '';
    if (rowInfo) {
      classNameValue = 'text-grey';
      const percentResponded = rowInfo.row.ratioResponded;
      if (percentResponded < 50) {
        classNameValue = 'text-red';
      }
      if (percentResponded >= 50 && percentResponded < 80) {
        classNameValue = 'text-orange';
      }
    }
    return { className: classNameValue };
  };

  render() {
    return (
      <DespatchMonitoringReport
        reportId={ReportDefinitions.DESPATCH_MONITORING_RESPONSE_PERFORMANCE.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        getTrProps={this.getTrProps}
      />
    );
  }
}

function mapStateToProps(state, props) {
  return {
    data: getCalculatedData(state, props),
    generatedDateTime: getGeneratedOnDateTime(state, props),
    isLoading: getIsLoading(state, props),
    columns: getColumns(state, props),
  };
}

DespatchMonitoringResponsePerformanceContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(DespatchMonitoringResponsePerformanceContainer);

